/* eslint-disable @typescript-eslint/no-empty-interface */
import { types, SnapshotOut, Instance } from "mobx-state-tree";

import { CourseModel } from "../Course/CourseModel";
import { UnitModel } from "../Unit/UnitModel";

export const PassingModel = types.model({
  id: types.identifier,
  markPercent: types.maybeNull(types.number),
  markTestPercent: types.maybeNull(types.number),
  passingPercent: types.maybeNull(types.number),
  passingTestPercent: types.maybeNull(types.number),

  // Используются только в модалке ModalTestResult
  mark: types.maybeNull(types.number),
  testingKind: types.maybeNull(types.string),
  cefrLevel: types.maybeNull(types.string),
  courseMark: types.maybeNull(types.number),

  course: types.maybeNull(types.late(() => types.reference(CourseModel))),
  units: types.optional(
    types.array(types.late(() => types.reference(UnitModel))),
    []
  ),
});

type PassingModelType = Instance<typeof PassingModel>;
export interface Passing extends PassingModelType {}
type PassingModelTypeSnapshotType = SnapshotOut<typeof PassingModel>;
export type PassingSnapshot = PassingModelTypeSnapshotType;
